import { isMobileApp } from '../../helpers/isMobileApp';
import { isMobileWeb } from '../../helpers/isMobileWeb';

export type PlatformType = 'mobile app' | 'mobile web' | 'desktop web';

/**
 * Resolve o tipo de plataforma atual para segmentação no Amplitude.
 *
 * A ordem de checagem é intencional: o app mobile renderiza dentro de um WebView
 * cujo viewport também satisfaz `isMobileWeb`, então o app precisa ser detectado
 * antes para não ser classificado como `mobile web`.
 *
 * @returns
 * - `mobile app`: aplicação rodando dentro do WebView do app mobile;
 * - `mobile web`: navegador com viewport de mobile;
 * - `desktop web`: demais casos.
 */
export function getPlatformType(): PlatformType {
  if (isMobileApp()) return 'mobile app';
  if (isMobileWeb('md')) return 'mobile web';
  return 'desktop web';
}
